(() => {
  if (customElements.get('multi-slideshow')) {
    return;
  }

  class MultiSlideshow extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) || 3000;
    }

    connectedCallback() {
      if (!this.enableSlider) return;

      this.initSlider();
      this.toggleArrows();
      window.addEventListener('resize', this.toggleArrows.bind(this));
    }

    initSlider() {
      const slider = this.querySelector('.collection-slider');
      if (!slider) return;

      const prevBtn = this.querySelector('.prev');
      const nextBtn = this.querySelector('.next');

      this.slider = new Swiper(slider, {
        slidesPerView: 1.3,
        spaceBetween: 0,
        loop: false,
        autoplay: this.autoplay ? {
          delay: this.speed,
          disableOnInteraction: false,
        } : false,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          1025: {
            slidesPerView: 2.5,
            spaceBetween: 0,
          }
        }
      });
    }

    toggleArrows() {
      if (!this.slider) return;

      const slidesPerView = this.slider.params.slidesPerView;
      const totalSlides = this.slider.slides.length;
      const prevBtn = this.querySelector('.prev');
      const nextBtn = this.querySelector('.next');

      if (totalSlides <= slidesPerView) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      }
    }
  }

  customElements.define('multi-slideshow', MultiSlideshow);
})();